import React, { useEffect } from 'react';
import { useHistory, Route } from 'react-router-dom';
import ProtectedRoute from 'shared/components/ProtectedRoute';
import Motif from '@liveramp/motif/core/Motif';
import Loader from '@liveramp/motif/core/Loader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { whoAmI } from 'shared/api/authorization';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'shared/store/rootReducer';
import { setIsUserLoggedIn } from 'shared/store/features/isUserLoggedInSlice';
import Alert from 'shared/components/Alert';
import Layout from './Layout';
import BillingDashboard from './BillingDashboard';
import Authorization from './Authorization';

const App = () => {
  const { isUserLoggedIn } = useSelector(
    (state: RootState) => state.isUserLoggedIn
  );
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    if (history.location.pathname !== '/login') {
      whoAmI()
        .then(() => {
          dispatch(setIsUserLoggedIn({ isUserLoggedIn: true }));
        })
        .catch(() => {
          dispatch(setIsUserLoggedIn({ isUserLoggedIn: false }));
          window.location.href = `${process.env.REACT_APP_SSO_URL}/login?service=${window.location.href}login`;
        });
    }
  }, []);

  return (
    <Motif>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Alert />
        <Layout>
          {
            !isUserLoggedIn && <Loader />
          }
          <Route
            path="/login"
            component={Authorization}
            exact
          />
          <ProtectedRoute
            path="/"
            isAccessible={isUserLoggedIn}
            redirectToWhenInaccessible="/"
            component={BillingDashboard}
            exact
          />
        </Layout>
      </MuiPickersUtilsProvider>
    </Motif>
  );
};

export default App;
